<template>
    <div>
        <form>

            <!-- paste from hq below here -->

            <div class="">
                <h1>Ledger</h1>
                <div>
                    <Checkbox
                        class="flex center bottom-15"
                        id="active"
                        value=1
                        v-model="record_data.active"
                        label="Active"
                        :disabled="!isEditable"
                    /></div>
                <div class="flex colx4 wrap">
                    <div><Input
                        type="text"
                        name="description"
                        id="description"
                        placeholder="Description"
                        v-model="record_data.description"
                        label="Description"
                        :disabled="!isEditable"
                    /></div>
                    <div><Dropdown
                        v-model="record_data.client_id"
                        id="client_id"
                        name="client_id"
                        label="Client Id"
                        :options="[{text:'', value:'3'},{text:'', value:'4'},{text:'', value:'5'},{text:'', value:'6'},{text:'', value:'39'},{text:'', value:'33'},{text:'', value:'40'},{text:'', value:'60'},{text:'', value:'59'},{text:'', value:'58'},{text:'', value:'57'},{text:'', value:'41'},{text:'alex@dentalintranet.com', value:'36'},{text:'alex@dentalintranet.com', value:'56'},{text:'alex@dentalintranet.com', value:'35'},{text:'alex@dentalintranet.com', value:'34'},{text:'alex@dentalintranet.com', value:'30'},{text:'alex@dentalintranet.com', value:'29'},{text:'alex@dentalintranet.com', value:'37'},{text:'alex@dentalintranet.com', value:'38'},{text:'alex@dentalintranet.com', value:'8'},{text:'alex@dentalintranet.com', value:'7'},{text:'jane.doe@gmail.com', value:'2'},{text:'john.doe@gmail.com', value:'1'},{text:'jrow+julia.ryabinov@mentistic.com', value:'61'},{text:'mental@dentalintranet.com', value:'32'},{text:'mental@dentalintranet.com', value:'31'},{text:'mental@dentalintranet.com', value:'18'},{text:'mental@dentalintranet.com', value:'14'},{text:'mental@dentalintranet.com', value:'13'},{text:'mental@dentalintranet.com', value:'12'},{text:'mental@dentalintranet.com', value:'11'},{text:'mental@dentalintranet.com', value:'10'},{text:'mental@dentalintranet.com', value:'9'},{text:'mental@dentalintranet.com', value:'28'},{text:'mental@dentalintranet.com', value:'15'},{text:'mental@dentalintranet.com', value:'16'},{text:'mental@dentalintranet.com', value:'17'},{text:'mental@dentalintranet.com', value:'19'},{text:'mental@dentalintranet.com', value:'20'},{text:'mental@dentalintranet.com', value:'21'},{text:'mental@dentalintranet.com', value:'22'},{text:'mental@dentalintranet.com', value:'23'},{text:'mental@dentalintranet.com', value:'24'},{text:'mental@dentalintranet.com', value:'25'},{text:'mental@dentalintranet.com', value:'26'},{text:'mental@dentalintranet.com', value:'27'},{text:'rr+julia.ryabinov@mentistic.com', value:'62'},{text:'tchil7010@gmail.com', value:'49'},{text:'tchil7010@gmail.com', value:'50'},{text:'tchil7010@gmail.com', value:'51'},{text:'tchil7010@gmail.com', value:'52'},{text:'tchil7010@gmail.com', value:'53'},{text:'tchil7010@gmail.com', value:'54'},{text:'tchil7010@gmail.com', value:'55'},{text:'tchil7010@gmail.com', value:'48'},{text:'tchil7010@gmail.com', value:'47'},{text:'tchil7010@gmail.com', value:'46'},{text:'tchil7010@gmail.com', value:'45'},{text:'tchil7010@gmail.com', value:'44'},{text:'tchil7010@gmail.com', value:'43'},{text:'tchil7010@gmail.com', value:'42'},{text:'', value:'0'},]"
                        required
                        :readonly="!isEditable"
                    /></div>
                    <div><Input
                        type="text"
                        name="from_type"
                        id="from_type"
                        placeholder="From Type"
                        v-model="record_data.from_type"
                        label="From Type"
                        :disabled="!isEditable"
                    /></div>
                    <div><Input
                        type="text"
                        name="from_acct_id"
                        id="from_acct_id"
                        placeholder="From Acct Id"
                        v-model="record_data.from_acct_id"
                        label="From Acct Id"
                        :disabled="!isEditable"
                    /></div>
                    <div><Input
                        type="text"
                        name="to_type"
                        id="to_type"
                        placeholder="To Type"
                        v-model="record_data.to_type"
                        label="To Type"
                        :disabled="!isEditable"
                    /></div>
                    <div><Input
                        type="text"
                        name="to_acct_id"
                        id="to_acct_id"
                        placeholder="To Acct Id"
                        v-model="record_data.to_acct_id"
                        label="To Acct Id"
                        :disabled="!isEditable"
                    /></div>
                    <div><Input
                        type="text"
                        name="service_item_id"
                        id="service_item_id"
                        placeholder="Service Item Id"
                        v-model="record_data.service_item_id"
                        label="Service Item Id"
                        :disabled="!isEditable"
                    /></div>
                    <div><Input
                        type="text"
                        name="invoice_id"
                        id="invoice_id"
                        placeholder="Invoice Id"
                        v-model="record_data.invoice_id"
                        label="Invoice Id"
                        :disabled="!isEditable"
                    /></div>
                    <div><Input
                        type="text"
                        name="payment_id"
                        id="payment_id"
                        placeholder="Payment Id"
                        v-model="record_data.payment_id"
                        label="Payment Id"
                        :disabled="!isEditable"
                    /></div>
                    <div><Input
                        type="text"
                        name="insurance_claim_id"
                        id="insurance_claim_id"
                        placeholder="Insurance Claim Id"
                        v-model="record_data.insurance_claim_id"
                        label="Insurance Claim Id"
                        :disabled="!isEditable"
                    /></div>
                    <div><Input
                        type="text"
                        name="amount"
                        id="amount"
                        placeholder="Amount"
                        v-model="record_data.amount"
                        label="Amount"
                        :disabled="!isEditable"
                    /></div>
                </div>
                <!--form_extra-->
            </div>


        </form>
    </div>
</template>
<script>
    const api_root = 'ledger'

    export default {
        name: 'LedgerDetail',
        props: {
            record_id: [String, Number],
        },
        data() {
            return {
                record_data : {
                    active : 0,
                    description : '',
                    client_id : 1,
                    from_type : '',
                    from_acct_id : 1,
                    to_type : '',
                    to_acct_id : 1,
                    service_item_id : 1,
                    invoice_id : 1,
                    payment_id : 1,
                    insurance_claim_id : 1,
                    amount : 1,
                    // fields from hq
                },
                isEditable : 1,
                record_actions : {
                    getRecordDetails: (id) => `/${api_root}/${id}`,
                }
            }
        },
        methods: {
            async init() {
                if (!(this.record_id === 'new')) {
                    const res = await this.$api.get(this.record_actions.getRecordDetails(this.record_id))

                    if (res.status === 404 || res.status === 500) {
                        this.$toasted.error('Could not find record')
                        return this.$router.replace({ name: 'NotFound' })
                    } else {
                        this.record_data = res.data.info[0]
                    }
                }
            },
            async validateForm() {
                const isValid = 1 // await this.$refs.form.validate()

                if (!isValid) {
                    this.$toasted.error('Please fill out all required fields.')
                }

                return isValid
            },
        },
        async created() {
            await this.init()
        },
        watch: {
            async $route() {
                await this.init()
            },
        },
    }
</script>
